import React, {useState} from 'react';
import Popup from '../common/CommonPopup';

const BaseVideoMenu = ({ iconSvg, title, data, convertFunc }) => {

  const [showPopup, setShowPopup] = useState(false);
  const [viewVideoUrl, setViewVideoUrl] = useState('');

  const formatDateTime = (isoString) => {
    if (!isoString) return '';

  const date = new Date(isoString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // 0부터 시작
  const day = String(date.getDate()).padStart(2, '0');

  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  const handleNewType = (idx, url) => {
    convertFunc(idx);
    setShowPopup(true);
    setViewVideoUrl(url);
    data.map(el =>{
      if(el.idx === idx){
        el.isNew = "N";
      }
    });
  };

  return (
    <>
    <div className="base-video-list-section">
        <h3 className="section-title">
            {iconSvg}
            {title}
        </h3>
        <div className="base-video-list-box">
            {data?.map((video, index) => (
              <div key={index} className={`youtube-video-item ${video.isNew == "Y" ? 'new-item' : ''}`}>
                <div class="youtube-video-thumbnail" onClick={() => {handleNewType(video.idx, video.url); }}>
                  <img src={video.imageUrl} alt="홍보영상" />
                  <div class="youtube-video-play-button"></div>
                </div>
              </div>
            )) || []}
        </div>
    </div>
    <Popup show={showPopup} onClose={() => setShowPopup(false)} type="youtube" url={viewVideoUrl}/>
    </>
    
  );
};

export default BaseVideoMenu;